import {
  CardSubTypePipe,
  CardTypeCallToActionsPipe,
  CardTypePipe,
  CardTypeRouteTypePipe,
  CourseDetailRoutePipe,
  CourseDetailTypeCallToActionsPipe,
  CourseSubscriptionTooltipPipe,
  CourseTypeRoutePipe,
  DecodeEntitiesPipe,
  FormatDurationPipe,
  InstructionTypeCustomButtonPipe,
  InstructionTypeCustomHeaderPipe,
  InstructionTypeIconPipe,
  LayoutColumnPipe,
  RouteTypesByCallToActionsPipe,
  SafePipe,
  SessionEnrollmentCallToActionsPipe,
  SessionEnrollmentRoutePipe,
  ShowCardSubHeaderTitlePipe,
  ShowDurationByInstructionTypePipe,
  SubscriptionIconPipe,
  SubscriptionNamePipe,
  SubscriptionPipe,
  TruncatePipe,
  UtcDateFormatPipe,
} from './_index';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

const declarations = [
  CardSubTypePipe,
  CardTypeCallToActionsPipe,
  CardTypeRouteTypePipe,
  CardTypePipe,
  CourseDetailRoutePipe,
  CourseDetailTypeCallToActionsPipe,
  CourseSubscriptionTooltipPipe,
  CourseTypeRoutePipe,
  DecodeEntitiesPipe,
  FormatDurationPipe,
  InstructionTypeCustomButtonPipe,
  InstructionTypeCustomHeaderPipe,
  InstructionTypeIconPipe,
  LayoutColumnPipe,
  RouteTypesByCallToActionsPipe,
  SafePipe,
  SessionEnrollmentCallToActionsPipe,
  SessionEnrollmentRoutePipe,
  ShowCardSubHeaderTitlePipe,
  ShowDurationByInstructionTypePipe,
  SubscriptionIconPipe,
  SubscriptionNamePipe,
  SubscriptionPipe,
  TruncatePipe,
  UtcDateFormatPipe,
];

@NgModule({
  imports: [CommonModule],
  declarations: declarations,
  exports: [...declarations],
})
export class PipesModule {}
